module.exports = angular.module('msi.shipments.shipmentOrchestrator', [
  require('@ordergroove/brandy/src/app/cookies')
]).name;

const inject = ['cookiesService', 'ogsdk.orderService', 'ogsdk.Order'];

class ShipmentOrchestrator {
  constructor(cookiesService, orderService, Order) {
    this.cookiesService = cookiesService;
    this.orderService = orderService;
    this.orderStatuses = Order.Statuses;

    this.getUnsentShipments = this.getUnsentShipments.bind(this);
  }

  getUnsentShipments() {
    return this.orderService.getAll({ status: this.orderStatuses.UNSENT, pagination: { pageSize: 100 } });
  }

  getSentShipments() {
    return this.orderService.getAll({ status: this.orderStatuses.SEND_NOW, pagination: { pageSize: 100 } });
  }

  changeShipmentDate(shipmentPublicId, placeDate) {
    return this.orderService.changePlaceDate(shipmentPublicId, placeDate)
      .then(this.getUnsentShipments)
      .then(this.cookiesService.removeOgImpulseCookie);
  }

  sendShipmentNow(shipmentPublicId) {
    return this.orderService.sendNow(shipmentPublicId)
      .then(this.getUnsentShipments)
      .then(this.cookiesService.removeOgImpulseCookie);
  }

  skipShipment(shipmentPublicId) {
    return this.orderService.cancel(shipmentPublicId)
      .then(this.getUnsentShipments)
      .then(this.cookiesService.removeOgImpulseCookie);
  }
}

ShipmentOrchestrator.$inject = inject;

angular.module(module.exports).service('shipmentOrchestrator', ShipmentOrchestrator);
